var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Edit/Edit-2/"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38956 10.9139L12.5867 2.7168C12.8757 2.42774 13.3444 2.42773 13.6334 2.71678L16.2833 5.36645C16.5723 5.65552 16.5724 6.12421 16.2833 6.41329L8.08622 14.6104C7.98816 14.7085 7.86452 14.777 7.72939 14.8082L4.86108 15.4707C4.06146 15.6554 3.34474 14.9386 3.5294 14.139L4.19174 11.2708C4.22295 11.1357 4.2915 11.012 4.38956 10.9139ZM4.50376 14.364L5.14934 11.5684L13.1101 3.60761L15.3925 5.88988L7.43178 13.8506L4.63605 14.4963C4.55664 14.5147 4.4854 14.4435 4.50376 14.364Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83325 16.4998C3.55711 16.4998 3.33325 16.7237 3.33325 16.9998C3.33325 17.276 3.55711 17.4998 3.83325 17.4998H16.1666C16.4427 17.4998 16.6666 17.276 16.6666 16.9998C16.6666 16.7237 16.4427 16.4998 16.1666 16.4998H3.83325Z",
    fill: "#5B5C5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.f39b2e9df671e8db39f0173b8764b975.svg";
export { ForwardRef as ReactComponent };